










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class MaterialIcon extends Vue {
  @Prop()
  private name!: string

  get parsed(): { suffix: string, id: string } {
    const themes:string[] = ['round', 'outlined'] // 使用するテーマをここに追加する eg. 'round', 'outlined'
    for (const theme of themes) {
      const suffix = theme
      if (this.name.endsWith(suffix)) {
        return {
          suffix: suffix,
          id: this.name.substring(0, this.name.indexOf(suffix) - 1)
        }
      }
    }
    return {
      suffix: '',
      id: this.name
    }
  }

  get standardClass(): string {
    if (this.parsed.suffix) {
      return `material-icons-${this.parsed.suffix}`
    }
    return 'material-icons'
  }
}
